<template>
    <v-row>
        <v-col md="6" sm="6" lg="4" v-for="card in allLiveAccounts" :key="card?.id">
            <v-card class="elevation-0 rounded-0 live-account-card"
                :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <v-card-actions>
                    <div class="trade-status">
                        <div :class="'icon-box' || 'icon-box-loss'">
                            <v-icon>mdi-arrow-up-thin</v-icon>
                        </div>
                        <div class="trade-number">
                            <span>MT5 -{{
                                card?.tradingaccounttypes
                                    .account_type_display
                            }}</span>
                            <span>{{ card?.trading_account_no }}</span>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="trade-dropdown">
                        <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
                            <template v-slot:activator="{ attrs, on }">
                                <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs"
                                    v-on="on" icon>
                                    <v-icon :color="$vuetify.theme.dark
                                        ? '#fff'
                                        : '#162334'
                                        ">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-card class="dropdown-menu-card" tile flat>
                                <v-list flat outlined :color="$vuetify.theme.dark
                                    ? '#111A26'
                                    : '#F1F7FB'
                                    ">
                                    <v-list-item-group>
                                        <v-list-item v-for="(item, i) in items" :key="i" :ripple="false" link>
                                            <v-list-item-content>
                                                <router-link v-text="item?.text" class="text-decoration-none" router
                                                    :to="{
                                                        path: item?.link,
                                                        query: {
                                                            id: card?.id,
                                                            ...((item.text === 'Change Leverage' || item.text === 'Change Trading Password') && { account: card?.trading_account_no })
                                                        },
                                                    }"></router-link>

                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card>
                        </v-menu>
                    </div>
                </v-card-actions>
                <v-card-actions>
                    <div class="value-trades">
                        <span>Trade value</span>
                        <span>{{ card?.Balance }}</span>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="value-trades">
                        <span>Trades</span>
                        <span>{{ card?.totalTrades }}</span>
                    </div>
                </v-card-actions>
                <v-card-actions>
                    <div class="currency-leverage">
                        <span>Currency</span>
                        <span>{{ card?.currency_name }}</span>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="currency-leverage">
                        <span>Leverage</span>
                        <span>1:{{ card?.leverage }}</span>
                    </div>
                </v-card-actions>
                <v-card-actions>
                    <div class="balance-equity">
                        <span>Balance</span>
                        <span>{{ card?.Balance?.toFixed(2) }}</span>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="balance-equity">
                        <span>Equity</span>
                        <span>{{ card?.Equity?.toFixed(2) }}</span>
                    </div>
                </v-card-actions>
                <v-card-actions class="pb-0">
                    <v-btn :to="{
                        path: 'live-trade-details',
                        query: { id: card?.id },
                    }" block outlined class="blink">
                        <v-icon class="blink" color="#FF567F">
                            mdi-circle-small
                        </v-icon>
                        See Live Trades
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data: () => ({
        items: [
            { text: "Deposit Funds", link: "/deposit" },
            { text: "Withdraw Funds", link: "/withdraw" },
            { text: "Internal Transfer", link: "/internal-transfer" },
            { text: "Change Trading Password", link: "/change-mt5-password" },
            { text: "Change Leverage", link: "/change-leverage" },
            { text: "Account Detail", link: "/trading-account-details" },
        ],
    }),
    computed: {
        ...mapState("trading", ["allLiveAccounts"]),
    },
    methods: {
        ...mapActions("trading", [TRADING__ACTIONS.ALLTRADEDETAILS]),
    },
    async mounted() {
        await this[TRADING__ACTIONS.ALLTRADEDETAILS]();
    },
};
</script>

<style></style>
